export const DEFAULT_ZOOM = 10;
export const DEFAULT_MAPS_LAYOUT = 'mapbox://styles/mapbox/streets-v10';

export const MAP_THUMBNAIL_WIDTH = 800;
export const MAP_THUMBNAIL_HEIGHT = 600;
